import React from 'react';
import classnames from 'classnames';

import { Auth, Intl } from 'components';

export default React.memo( ( { error, isLoading } ) => (
  <Auth
    title="activateNewAccount"
    className={classnames( { 'app-component-loading': isLoading } )}
  >
    {!isLoading
    && (
    <div className="text-center mt-3">
      {error
        ? (
          <>
            <i className="far fa-times-circle fa-4x text-gray-7 mb-3" />
            <p className="text-gray-7">
              <Intl id="activateNewAccountError" />
            </p>
          </>
        )
        : (
          <>
            <i className="far fa-check-circle fa-4x text-gray-7 mb-3" />
            <p className="text-gray-7">
              <Intl id="activateNewAccountSuccess" />
            </p>
          </>
        )}
    </div>
    )}
  </Auth>
) );
